import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export const documentValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    configService?: ConfigService,
  ) => Observable<boolean>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.UPLOAD_DOCUMENT,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(TransactionState.getTransactions);
      return data.subscribe({
        next: (res) => {
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: !res?.isFileUploading,
          });
        },
      });
    },
  ],
]);
